import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/AuthProvider';
import { useScreen } from '../lib/useScreen';
import { supabase } from '../lib/supabaseClient';

const font = "'DM Sans', sans-serif";
const serif = "'DM Serif Display', serif";
const C = { turquesa:'#5dc1b9', logoGrad:'linear-gradient(135deg, #534AB7, #1D9E75)' };

export default function EscribirHistoria() {
  const navigate = useNavigate();
  const { user, profile, membership } = useAuth();
  const { isMobile } = useScreen();
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [storyId, setStoryId] = useState(null);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const timerRef = useRef(null);

  // Load draft by ?draft=ID or nothing (new story)
  useEffect(() => {
    if (!user) return;
    const params = new URLSearchParams(window.location.search);
    const draftId = params.get('draft');
    if (draftId) {
      supabase.from('stories').select('*').eq('id', draftId).eq('user_id', user.id).single()
        .then(({ data }) => {
          if (data) { setTitle(data.title || ''); setContent(data.content || ''); setStoryId(data.id); }
        });
    }
  }, [user]);

  // Auto-save every 30s
  useEffect(() => {
    if (!title.trim()) return;
    timerRef.current = setInterval(() => save('draft', true), 30000);
    return () => clearInterval(timerRef.current);
  }, [title, content]);

  const save = async (status, silent) => {
    if (!user || saving) return;
    if (!silent) setSaving(true);
    const payload = {
      title, content, status,
      author_name: profile?.full_name || 'Anónimo',
      author_business: profile?.business_name || '',
      author_membership: membership,
      updated_at: new Date().toISOString(),
    };
    if (storyId) {
      const { error } = await supabase.from('stories').update(payload).eq('id', storyId);
      if (error) console.error('[stories] update error:', error.message);
    } else {
      payload.user_id = user.id;
      const { data, error } = await supabase.from('stories').insert(payload).select('id').single();
      if (error) console.error('[stories] insert error:', error.message);
      if (data) setStoryId(data.id);
    }
    if (!silent) { setSaving(false); navigate('/stories'); }
    else { setSaved(true); setTimeout(() => setSaved(false), 2000); }
  };

  return (
    <div style={{ minHeight:'100vh', background:'#0a0a0a', color:'#fff', fontFamily:font }}>
      {/* Minimal nav */}
      <div style={{ maxWidth:700, margin:'0 auto', padding:isMobile?'16px':'20px 0', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
        <button onClick={() => navigate('/stories')} style={{ background:'none', border:'none', color:C.turquesa, fontSize:14, fontWeight:500, cursor:'pointer', fontFamily:font, padding:isMobile?'0 16px':0 }}>← Volver a historias</button>
        {saved && <span style={{ fontSize:12, color:'rgba(93,193,185,0.7)' }}>Guardado automáticamente ✓</span>}
      </div>

      {/* Editor */}
      <div style={{ maxWidth:700, margin:'0 auto', padding:isMobile?'1rem':'2rem 0 4rem' }}>
        <input
          value={title} onChange={e => setTitle(e.target.value)}
          placeholder="Título de tu historia"
          style={{
            width:'100%', padding:isMobile?'0 16px':'0', border:'none', outline:'none',
            fontSize:isMobile?24:28, fontFamily:serif, fontWeight:400,
            background:'transparent', color:'#fff', boxSizing:'border-box',
            marginBottom:24, lineHeight:1.3,
          }}
        />
        <textarea
          value={content} onChange={e => setContent(e.target.value)}
          placeholder="Escribe tu historia aquí..."
          style={{
            width:'100%', padding:isMobile?'0 16px':'0', border:'none', outline:'none',
            fontSize:16, fontFamily:font, background:'transparent', color:'rgba(255,255,255,0.85)',
            minHeight:isMobile?400:500, resize:'none', boxSizing:'border-box', lineHeight:1.9,
          }}
        />

        {/* Buttons */}
        <div style={{ display:'flex', gap:10, marginTop:32, padding:isMobile?'0 16px':0, flexWrap:'wrap' }}>
          <button disabled={!title.trim()||!content.trim()||saving} onClick={() => save('published')}
            style={{ flex:1, minWidth:140, background:C.logoGrad, color:'#fff', border:'none', borderRadius:50, padding:'14px', fontSize:15, fontWeight:500, cursor:'pointer', fontFamily:font, opacity:(!title.trim()||!content.trim())?0.4:1 }}>
            {saving ? 'Publicando...' : 'Publicar historia'}
          </button>
          <button disabled={!title.trim()||saving} onClick={() => save('draft')}
            style={{ minWidth:140, background:'rgba(255,255,255,0.06)', border:'1px solid rgba(255,255,255,0.1)', borderRadius:50, padding:'14px 24px', fontSize:14, fontWeight:500, cursor:'pointer', fontFamily:font, color:'rgba(255,255,255,0.5)' }}>
            Guardar borrador
          </button>
        </div>
      </div>
    </div>
  );
}
